/**
 * @generated SignedSource<<3842abe754bfdaf2044ded28aae70f31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateReservationInput = {
  clientMutationId?: string | null | undefined;
  endsAt?: any | null | undefined;
  notes?: string | null | undefined;
  reservationId: string;
  startsAt?: any | null | undefined;
};
export type OpsReservationPageUpdateMutation$variables = {
  input: UpdateReservationInput;
};
export type OpsReservationPageUpdateMutation$data = {
  readonly updateReservation: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationPageUpdateMutation = {
  response: OpsReservationPageUpdateMutation$data;
  variables: OpsReservationPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateReservationPayload",
    "kind": "LinkedField",
    "name": "updateReservation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPageUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPageUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db13fc72ab52a553490c714535b57317",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationPageUpdateMutation(\n  $input: UpdateReservationInput!\n) {\n  updateReservation(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "32e4a2b5fe2447af96cfdd19bf331fc3";

export default node;
